module.exports = __webpack_public_path__ + "./docs/img/big-icon-method.f9c0182167612866e0e0616a1caf5d8c.svg";